import { useHttp } from "../http/useHttp";
import { useAxiosMfaMutation } from "../http/useAxiosMfaMutation";
import { paths } from "../generated-types";
import { useDefaultError } from "@synota-io/synota-shared-ui";

type HideContractOperation =
  paths["/dashboard/synota/contracts/{contract_shared_uuid}/hide"]["post"];
export type UseContractHideInput = HideContractOperation["parameters"]["path"] &
  HideContractOperation["requestBody"]["content"]["application/json"];

export const useContractHide = () => {
  const { client } = useHttp();

  const { isPending, status, data, error, mutate } = useAxiosMfaMutation<
    void,
    UseContractHideInput
  >({
    mutationKey: ["set-contract-hidden"],
    mutationFn: ({ contract_shared_uuid, ...input }) =>
      client.post(`/synota/contracts/${contract_shared_uuid}/hide`, input),
  });

  useDefaultError(error, "Failed to set contract visibility");

  return { setHidden: mutate, isPending, status, data, error };
};

export type UseContractHideReturn = ReturnType<typeof useContractHide>;
